var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgRedLineV2 = function SvgRedLineV2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 785,
    height: 300,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 119C62.667 286.833 246.6 273 507 283 832.5 295.5 851-2.5 575 18.5",
    stroke: "#FF3C3C",
    strokeWidth: 33
  })));
};
export default SvgRedLineV2;